const rss = {
  title: "RSS Feeds",
  description: "Israeli construction & real estate news",
  feeds: "Feeds",
  articles: "Articles",
  unread: "Unread",
  starred: "Starred",
  allArticles: "All Articles",
  addFeed: "Add Feed",
  feedUrl: "RSS URL",
  feedTitle: "Feed Name",
  keywords: "Keywords",
  keywordsPlaceholder: "real estate, construction, contractor...",
  syncNow: "Sync Now",
  syncing: "Syncing...",
  lastSynced: "Last Synced",
  never: "Never synced",
  activeFeeds: "Active Feeds",
  totalArticles: "Total Articles",
  unreadCount: "Unread",
  markRead: "Mark as Read",
  markAllRead: "Mark All Read",
  viewAll: "View All",
  openArticle: "Open Article",
  noArticles: "No articles yet — run a sync",
  noFeeds: "No active feeds",
  removeFeed: "Remove Feed",
  defaultFeed: "Default feed",
  customFeed: "Custom feed",
  error: "Error",
  synced: "Synced",
  stale: "Stale",
  matchedKeywords: "Matched keywords",
  filterByFeed: "Filter by feed",
  filterAll: "All",
  ago: "ago",
  minutes: "minutes",
  hours: "hours",
  days: "days",
  today: "Today",
  yesterday: "Yesterday",
} as const;
export default rss;
